import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { SingleInput } from '../interactions/SingleInput.jsx'
import { ToggleChip } from '../../../ui/ToggleChip/ToggleChip.jsx'

// Common mood suggestions — chip scaffold above the input
const SUGGESTIONS = [
  'energised', 'grateful', 'proud', 'anxious', 'overwhelmed',
  'hopeful', 'frustrated', 'calm', 'focused', 'uncertain',
]

/**
 * OneWordCard — single word input (soft cap 16 chars) + chip scaffold row.
 * catalog #17, prep-one-word. Adds chip suggestions row above input.
 */
export function OneWordCard({ card, value, onChange, disabled }) {
  const word = value?.word ?? ''
  const hasFill = !!word

  function handleChipClick(suggestion) {
    if (disabled) return
    onChange({ word: suggestion })
  }

  return (
    <CardFrame
      kind="prep"
      icon="◌"
      iconClass="clay"
      title="One word"
      prompt="What one word describes this week?"
      state={disabled ? 'locked' : hasFill ? 'filled' : 'empty'}
      data-testid="prep-card-prep-one-word"
      className="prepcard"
    >
      <div style={styles.suggestions} role="group" aria-label="Word suggestions">
        {SUGGESTIONS.map((s) => (
          <ToggleChip
            key={s}
            selected={word === s}
            disabled={disabled}
            onClick={() => handleChipClick(s)}
          >
            {s}
          </ToggleChip>
        ))}
      </div>
      <SingleInput
        value={value}
        onChange={onChange}
        maxChars={16}
        placeholder="or type your own…"
        centered
        fontSize="18px"
        disabled={disabled}
      />
    </CardFrame>
  )
}

const styles = {
  suggestions: { padding: '12px 14px 0', display: 'flex', flexWrap: 'wrap', gap: 6 },
}
